import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { 
  Code, 
  Smartphone, 
  Headphones, 
  Lightbulb, 
  Shield, 
  Briefcase, 
  DollarSign,
  Scale 
} from "lucide-react";
import { mockData } from "../mock/mockData";

const ServicesSection = () => {
  const { services } = mockData;

  const getServiceIcon = (iconName) => {
    const icons = {
      code: <Code className="w-8 h-8" />,
      smartphone: <Smartphone className="w-8 h-8" />,
      headphones: <Headphones className="w-8 h-8" />,
      lightbulb: <Lightbulb className="w-8 h-8" />,
      shield: <Shield className="w-8 h-8" />,
      briefcase: <Briefcase className="w-8 h-8" />,
      dollarsign: <DollarSign className="w-8 h-8" />,
      scale: <Scale className="w-8 h-8" />
    };
    return icons[iconName] || <Code className="w-8 h-8" />;
  };

  return (
    <section id="servicios" className="py-20 bg-gradient-to-br from-[#F6F6F6] via-white to-[#F6F6F6]">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#252F4A] mb-6">
            Nuestros <span className="text-[#3E97FF]">Servicios</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#3E97FF] to-[#27AE60] mx-auto mb-6"></div>
          <p className="text-lg text-[#252F4A]/70 max-w-2xl mx-auto">
            Impulsamos el éxito de tu negocio con soluciones integrales en gestión empresarial y tecnología, diseñadas para garantizar eficiencia, cumplimiento y confianza. Ofrecemos servicios expertos en gestión corporativa y seguridad social, y desarrollo innovador de soluciones tecnológicas a medida que transforman y fortalecen tu operación.
          </p>
        </div>

        {/* Technology Services */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#252F4A] mb-4 flex items-center justify-center gap-3">
              <Code className="w-8 h-8 text-[#3E97FF]" />
              {services.technology.title}
            </h3>
            <p className="text-[#252F4A]/70 text-lg">{services.technology.description}</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            {services.technology.items.map((service, index) => (
              <Card 
                key={index} 
                className="group hover:shadow-xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm"
              >
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#3E97FF]/10 to-[#1C3C73]/10 rounded-xl flex items-center justify-center group-hover:from-[#3E97FF]/20 group-hover:to-[#1C3C73]/20 transition-all duration-300">
                    <div className="text-[#3E97FF]">
                      {getServiceIcon(service.icon)}
                    </div>
                  </div>
                  <CardTitle className="text-xl text-[#252F4A] group-hover:text-[#3E97FF] transition-colors">
                    {service.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <CardDescription className="text-[#252F4A]/70 text-center">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Business Services */}
        <div>
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-[#252F4A] mb-4 flex items-center justify-center gap-3">
              <Briefcase className="w-8 h-8 text-[#27AE60]" />
              {services.business.title}
            </h3>
            <p className="text-[#252F4A]/70 text-lg">{services.business.description}</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {services.business.items.map((service, index) => (
              <Card 
                key={index} 
                className="group hover:shadow-xl hover:scale-105 transition-all duration-300 border-0 bg-white/80 backdrop-blur-sm"
              >
                <CardHeader className="text-center pb-4">
                  <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-[#27AE60]/10 to-[#FF6B35]/10 rounded-xl flex items-center justify-center group-hover:from-[#27AE60]/20 group-hover:to-[#FF6B35]/20 transition-all duration-300">
                    <div className="text-[#27AE60]">
                      {getServiceIcon(service.icon)}
                    </div>
                  </div>
                  <CardTitle className="text-xl text-[#252F4A] group-hover:text-[#27AE60] transition-colors">
                    {service.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <CardDescription className="text-[#252F4A]/70 text-center">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;